import Nullstack from 'nullstack';
export default function IconPlaylist({
  size = 24,
  color = "currentColor",
  stroke = 2
}) {
  const allProps = {
    width: size,
    height: size,
    "stroke-width": stroke,
    stroke: color
  };
  return Nullstack.element("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    class: "inline-flex icon icon-tabler icon-tabler-playlist",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    "stroke-width": "2",
    stroke: "currentColor",
    fill: "none",
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    ...allProps
  }, "   ", Nullstack.element("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), "   ", Nullstack.element("circle", {
    cx: "14",
    cy: "17",
    r: "3"
  }), "   ", Nullstack.element("path", {
    d: "M17 17v-13h4"
  }), "   ", Nullstack.element("path", {
    d: "M13 5h-10"
  }), "   ", Nullstack.element("line", {
    x1: "3",
    y1: "9",
    x2: "13",
    y2: "9"
  }), "   ", Nullstack.element("path", {
    d: "M9 13h-6"
  }), " ");
}